import {v4 as uuidv4} from 'uuid';
import {HelixTodayGiftDto} from '../../common/shared/api/nicolas/vo/HelixTodayGiftDto.interface';
import {getTicketExpiredText} from '../../common/shared/utils/getTicketExpiredText';
import {TodayGift} from '../generated/types';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createHelixTodayGift({
  is_received,
  ticket_count,
  ticket_type,
  helix_gift_uid,
  ticket_expire_at,
  series_id,
}: HelixTodayGiftDto): TodayGift {
  return {
    id: uuidv4(),
    ticketCount: ticket_count,
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    uid: helix_gift_uid,
    ticketExpireAt: ticket_expire_at,
    ticketExpiredText: getTicketExpiredText(ticket_expire_at),
    isReceived: is_received,
    seriesId: series_id,
  };
}
